<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconCheckmark_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M9.109 19.44c-.384 0-.768-.146-1.061-.439L2.076 13.03a1.5 1.5 0 1 1 2.121-2.12l4.912 4.91L19.96 4.967a1.5 1.5 0 1 1 2.121 2.121L10.169 19c-.293.293-.676.44-1.06.44"
    />
</svg>
